import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { IdexService } from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';

@Component({
  selector: 'app-edit-notification',
  templateUrl: './edit-notification.component.html',
  styleUrls: ['./edit-notification.component.css']
})
export class EditNotificationComponent implements OnInit {
    // Notification properties
  isNotifyTasks: boolean;
  isNotifyTaskCompleted: boolean;
  isNotifyAppDocDelete: boolean;
  isNotifyAppDocShared: boolean;
  isNotifyAppMoveDoc: boolean;
  isNotifyAppReceiveTask: boolean;
  isNotifyAppRejectTask: boolean;
  isNotifyAppReassignTask: boolean
  isNotifyAppRemindTask: boolean;
  isNotifyAppRenameDoc: boolean;
  isNotifyAppRevertDoc: boolean;
  isNotifyAppTaskComplete: boolean;
  isNotifyAppTaskDelete: boolean;
  isNotifyAppUpdateDoc: boolean;
  isNotifyAppUpdateMet: boolean;
  isNotifyTasksAll: boolean = false;
  isNotifyTasksAppAll: boolean = false;
  @ViewChildren('notifyCheckbox') checkboxes: QueryList<any>;
  @ViewChildren('notifyAppCheckbox') checkAppboxes: QueryList<any>;

  constructor(protected service: IdexService, public toast: Toast) { }

  ngOnInit(): void {
    this.service.getProfile()
    .subscribe((data: any) => {
       // Assign received values to corresponding properties
       this.isNotifyTasks = data.isNotifyTasks;
       this.isNotifyTaskCompleted = data.isNotifyTaskCompleted;
       this.isNotifyAppReceiveTask = data.isNotifyAppReceiveTask;
       this.isNotifyAppRejectTask = data.isNotifyAppRejectTask;
       this.isNotifyAppReassignTask = data.isNotifyAppReassignTask;
       this.isNotifyAppRemindTask = data.isNotifyAppRemindTask;
       this.isNotifyAppTaskDelete = data.isNotifyAppTaskDelete;
       this.isNotifyAppTaskComplete = data.isNotifyAppTaskComplete;
       this.isNotifyAppUpdateDoc = data.isNotifyAppUpdateDoc;
       this.isNotifyAppRevertDoc = data.isNotifyAppRevertDoc;
       this.isNotifyAppUpdateMet = data.isNotifyAppUpdateMet;
       this.isNotifyAppRenameDoc = data.isNotifyAppRenameDoc;
       this.isNotifyAppMoveDoc = data.isNotifyAppMoveDoc;
       this.isNotifyAppDocShared = data.isNotifyAppDocShared;
       this.isNotifyAppDocDelete = data.isNotifyAppDocDelete;

       // Check all Notification preferences
       if(this.isNotifyTasks && this.isNotifyTaskCompleted){
          this.isNotifyTasksAll = true;
       }

       const notifications = [
        this.isNotifyAppReceiveTask,
        this.isNotifyAppRejectTask,
        this.isNotifyAppReassignTask,
        this.isNotifyAppTaskDelete,
        this.isNotifyAppTaskComplete,
        this.isNotifyAppUpdateDoc,
        this.isNotifyAppRevertDoc,
        this.isNotifyAppDocDelete,
        this.isNotifyAppUpdateMet,
        this.isNotifyAppRenameDoc,
        this.isNotifyAppMoveDoc,
        this.isNotifyAppDocShared,
      ];
      
      if (notifications.every(notification => notification)) {
          this.isNotifyTasksAppAll = true;
      }
    });
  }

  // Update notification preferences
  updateNotifyApp(){
  // Call the service to update notification preferences
    this.service.updateNotifyApp(this.isNotifyTasks, this.isNotifyTaskCompleted, this.isNotifyAppReceiveTask, this.isNotifyAppRejectTask, this.isNotifyAppReassignTask, 
      this.isNotifyAppRemindTask, this.isNotifyAppTaskDelete, this.isNotifyAppTaskComplete, this.isNotifyAppUpdateDoc, this.isNotifyAppRevertDoc, this.isNotifyAppUpdateMet, 
      this.isNotifyAppRenameDoc, this.isNotifyAppMoveDoc, this.isNotifyAppDocShared, this.isNotifyAppDocDelete)
      .subscribe((response) => {
        this.toast.success(response);
      }, (error) => {
        this.toast.error(error);
      });
  }

  onNotifyAllChange() {
    // When Notify is checked, update Notify All accordingly
    this.isNotifyTasks = this.isNotifyTasksAll;
    this.isNotifyTaskCompleted = this.isNotifyTasksAll;
  }

  onNotifyChange() {
    const selectedCheckboxes = this.checkboxes.filter(checkbox => checkbox.checked);
    const selectedCheckAppboxes = this.checkAppboxes.filter(checkbox => checkbox.checked);
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked === false) {
        this.isNotifyTasksAll = false;
      }
      if (selectedCheckboxes.length === 2) {
        this.isNotifyTasksAll = true;
      } 
    });
    this.checkAppboxes.forEach((checkbox) => {
      if (checkbox.checked === false) {
        this.isNotifyTasksAppAll = false;
      }
      if (selectedCheckAppboxes.length === 12) {
        this.isNotifyTasksAppAll = true;
      } 
    });
  }
  onNotifyAppAllChange() {
    // When Notify is checked, update Notify Application All accordingly
    this.isNotifyAppReceiveTask = this.isNotifyTasksAppAll;
    this.isNotifyAppRejectTask = this.isNotifyTasksAppAll;
    this.isNotifyAppReassignTask = this.isNotifyTasksAppAll;
    this.isNotifyAppRemindTask = this.isNotifyTasksAppAll;
    this.isNotifyAppTaskDelete = this.isNotifyTasksAppAll;
    this.isNotifyAppTaskComplete = this.isNotifyTasksAppAll;
    this.isNotifyAppUpdateDoc = this.isNotifyTasksAppAll;
    this.isNotifyAppRevertDoc = this.isNotifyTasksAppAll;
    this.isNotifyAppUpdateMet = this.isNotifyTasksAppAll;
    this.isNotifyAppRenameDoc = this.isNotifyTasksAppAll;
    this.isNotifyAppMoveDoc = this.isNotifyTasksAppAll;
    this.isNotifyAppDocShared = this.isNotifyTasksAppAll;
    this.isNotifyAppDocDelete = this.isNotifyTasksAppAll;
  }
}